import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoRetail = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Retail</title>
    <path
      d="M11.214 13.018V8.76m9.524 4.26v-4.26m0 0V7.48A2.978 2.978 0 0 0 17.76 4.5H14.193a2.978 2.978 0 0 0-2.979 2.978V8.76m9.524 0h-9.524m0 0h12.307a2.979 2.979 0 0 1 2.979 2.979v12.784a2.978 2.978 0 0 1-2.979 2.978H8.479A2.978 2.978 0 0 1 5.5 24.521V11.739a2.979 2.979 0 0 1 2.979-2.979h2.735Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoRetail;
